import {
  ApiAction,
  ApiState,
  SET_APIS,
  SET_APIS_LOADED,
  SET_SELECTED_API,
} from '../types'

const initialState: ApiState = {
  apis: [],
  isApisLoaded: false,
}

export const apiReducer = (
  state = initialState,
  action: ApiAction
): ApiState => {
  switch (action.type) {
    case SET_APIS:
      return {
        ...state,
        apis: action.payload,
      }
    case SET_APIS_LOADED:
      return {
        ...state,
        isApisLoaded: action.payload,
      }
    case SET_SELECTED_API:
      return {
        ...state,
        selectedApi: action.payload,
      }
    default:
      return state
  }
}
